<template>
    <iframe :src="src" v-on:load="loaded" style="min-height: 500px; height: 100%; overflow: auto"></iframe>
  <!--<iframe id="iframe" :src="src" scrolling="no" v-on:load="loaded" style="min-height: 500px"></iframe>-->
</template>

<script>
    import iFrameResize from 'iframe-resizer'
    import {scroll} from 'quasar-framework'

    const {setScrollPosition} = scroll

    export default {
        name: 'VIFrame',

        props: {
            src: {
                type: String,
                required: true
            },
            autoresize: {
                type: Boolean,
                default: true
            }
        },

        mounted() {
            this.$loading(true)
            iFrameResize.iframeResizer({
                log: true, checkOrigin: false,
                autoResize: this.autoresize
            }, `#iframe`)
        },

        methods: {
            loaded() {
                this.$loading(false)
                window.scrollTo(0,0)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/IFrame.vue